import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomerService from '../../api/CustomerService';
import { generateUUIDFromID } from '../../services/UUIDGeneratorService';
import { SelectedCustomer, productManagementActions } from '../../store/product-management-slice';
import { allowOnlyDecimals } from '../../utils/allowOnlyDecimals';
import { CustomButton } from '../CustomButton/CustomButton';

import styles from './addProductModalTabs.module.css';
import { AssignListModal } from './AssignListModal';
import { Column, Table } from './Table';

export const KundenTab = () => {
    const dispatch = useDispatch();
    const extendedPrices = useSelector((state: any) => state.productManagement.product.extendedPrices);

    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearchTerm] = useState('');
    const [customers, setCustomers] = useState([]);

    const columns: Column<any>[] = [
        {
            key: "customerName",
            label: "Kunden name",
        },
        {
            key: "price",
            label: "Kaufpreis",
        }
    ];
    const tableData = useMemo(() => extendedPrices.map((item: SelectedCustomer) => ({ customerName: item.customerName, price: item.price ? `${item.price} EUR` : "0 EUR" })), [extendedPrices]);
    const getCustomers = async () => {
        try {
            const response = await CustomerService.GetSevDeskCustomers();
            setCustomers(response.data.map((customer: any) => ({
                ...customer, id: generateUUIDFromID(customer.id.toString()),
            })));
        } catch (error) {
            console.log(error);
        }

    };

    const renderCustomerPriceInput = (customer: any, selectedItems: SelectedCustomer[], setSelectedItems: React.Dispatch<React.SetStateAction<SelectedCustomer[]>>) => {
        const selectedCustomer = selectedItems.find((item) => item.customerId === customer.id);

        return (
            <div className={styles["tab-zubehor__customer-price-container"]}>
                <input
                    className={styles["tab-zubehor__customer-price"]}
                    type="text"
                    inputMode="decimal"
                    placeholder="0,00"
                    value={selectedCustomer?.price}
                    onChange={(e) => {
                        const input = allowOnlyDecimals(e.target.value);
                        setSelectedItems((prev) =>
                            prev.map((item) => item.customerId === customer.id ? { ...item, price: input ?? 0 } : item));
                    }}
                />
                €
            </div>
        );
    }

    const filteredCustomers = useMemo(() => {
        const searchTerm = search.trim().toLocaleLowerCase('de-DE');

        if (!searchTerm) {
            return customers;
        }

        return customers.filter((customer: any) =>
            customer.name?.toLocaleLowerCase('de-DE').includes(searchTerm)
        );
    }, [customers, search]);

    useEffect(() => {
        getCustomers();
    }, [])

    const handleSaveCustomers = (selectedItems: SelectedCustomer[]) => {
        dispatch(productManagementActions.setExtendedPrices(selectedItems));
    };

    return <div className={styles["tab-zubehor"]}>
        <div className={styles["tab-zubehor-header"]}>
            <div></div>
            <CustomButton onClick={() => setIsOpen(true)} color='lightGreenNew' icon={extendedPrices.length ? 'edit' : 'add'} iconPosition='left' customClass={styles["zubehor-tab-bearbeiten-button"]}>{extendedPrices.length ? 'Bearbeiten' : 'Hinzufügen'}</CustomButton>
        </div>
        <Table data={tableData} columns={columns} empty={{ title: 'Keine Kunden zugeordnet', text: 'Klicken Sie auf "Hinzufügen", um Kunden hinzuzufügen' }} />
        <AssignListModal<Customer, SelectedCustomer>
            isOpen={isOpen}
            title="Kunden zuweisen"
            onClose={() => setIsOpen(false)}
            data={filteredCustomers}
            setSearch={setSearchTerm}
            search={search}
            selectedItems={extendedPrices}
            onSave={handleSaveCustomers}
            getId={(customer) => customer.id}
            isSelected={(customer, selectedItems) => selectedItems.some((item) => item.customerId === customer.id)}
            onToggle={(customer, enabled, selectedItems) => {
                if (enabled) {
                    return [...selectedItems, { customerId: customer.id, customerName: customer.name ?? `${customer.surename} ${customer.familyname}`, price: undefined }];
                }
                return selectedItems.filter(
                    (item) =>
                        item.customerId !== customer.id
                );
            }}
            renderInfo={(customer) => <p className={styles["tab-zubehor-customer-name"]}>{customer.name ?? `${customer.surename} ${customer.familyname}`}</p>}
            renderSelectedContent={renderCustomerPriceInput}

            hasMore={false}

        />
    </div>;
};